import React, { useEffect } from 'react';

import './HomeButton.css'; // Możesz użyć zewnętrznego pliku CSS do stylów
import { useNavigate } from 'react-router';

const HomeButton = ({ to, icon, title, description, callback  }) => {
  const nav = useNavigate()
  
  console.log('s')

  const handleClick = () => {
    if(callback)
      callback()
    
    nav(to)
  }

  return (
      <div className='home-button' onClick={handleClick}>
      <div className="home-button-icon">{icon}</div>
      <div className="home-button-text">
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
  </div>
  );
};

export default HomeButton;